<div class="row me-0" style="display: flex;
    text-align: end;" *ngIf="global.OnboardType != 'EMPLOYEE' && global.OnboardType != 'CLIENT'">
    <div>
        <button class="btn btn-sm btn-primary" type="button"
            [disabled]="global.viewTabs || global.LoginUserType == 'Onboard'" data-bs-toggle="modal"
            data-bs-target="#Generatemodal" (click)="OpenGenerateDynamicForm('generate')">
            Add
        </button>
    </div>
</div>


<div class="row mt-2 ">
    <div class="col-lg-12">
        <ejs-grid #gridDynamicForm [dataSource]='GridDataList | async' [allowResizing]='true'
            (actionBegin)="onActionComplete($event)" [pageSettings]='initialPage' [filterSettings]='filterOptions'
            [allowFiltering]="true" (dataStateChange)='dataStateChange($event)' [allowPaging]='true'
            (resizeStop)="onResize($event)" [showColumnChooser]='true' [allowSorting]="true">
            <e-columns>
                <!-- Action -->
                <e-column headerText="Actions" uid='action' textAlign='center' [allowEditing]='false'
                    [allowFiltering]="false" [showInColumnChooser]='false'>
                    <ng-template #template let-data>
                        <button class="btn btn-edit-table" [disabled]="global.viewTabs" *ngIf="data.isCompleted ==false"
                            (click)="checkDownloadType(data);dynamicFormScheduleRefresh(); isAutosave=false;pdfsrc=null"><i
                                class="fa fa-edit"></i></button>
                        <button class="btn btn-edit-table ms-2" *ngIf="data.isCompleted" [disabled]="global.viewTabs"
                            (click)="viewClientCompltedDynamicforms(data.id)"><i class="fa fa-eye"></i></button>
                        <button class="btn btn-sm ms-2" style="background-color:#502189 ;" title="Note"
                            (click)="getOfficeNotes(data)" data-bs-toggle="modal" data-bs-target="#modalofficeNotes"
                            *ngIf="this.global.OnboardingLoginType !='onboardLogin'"><i
                                class="fa fa-sticky-note-o"></i></button>
                        <button *ngIf="this.global.OnboardingLoginType !='onboardLogin' && fp.DeleteDynamicTemplate"
                            class="btn btn-delete-table ms-2" data-bs-toggle="modal" [disabled]="global.viewTabs"
                            data-bs-target="#deletedoc" (click)="setDynamicId(data)"><i
                                class="fa fa-trash"></i></button>
                        <button class="btn btn-edit-table ms-2" [disabled]="global.viewTabs"
                            (click)="downloadUrl(data.id)"><i class="fa fa-download"></i></button>
                    </ng-template>
                </e-column>
                <!-- Client &  Employee -->
                <e-column minWidth=100 field="clientName" *ngIf="ListCEInputProperty.details.Dynamictype == 'Client'"
                    headerText="Client Name" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="employeeName"
                    *ngIf="ListCEInputProperty.details.Dynamictype == 'Employee' || ListCEInputProperty.details?.dynamicClientType =='Employee'"
                    headerText="Employee Name" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="clientName"
                    *ngIf="ListCEInputProperty.details.Dynamictype == 'Employee' || ListCEInputProperty.details?.dynamicClientType =='Employee'"
                    headerText="Employer Name" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <!-- DynamicForm TemplateName -->
                <e-column minWidth=100 field="dynamicFormTemplateName" headerText="Template Name" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <!-- CreatedOn -->
                <!-- <e-column minWidth=100 field="createdOn" headerText="Create Date" type='date' [format]='formatOptions'
                    [allowFiltering]="false" [allowSorting]="false">
                </e-column>
                <e-column minWidth=100 field="dynamicFormGroupName" headerText="Group Name" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column> -->

                <e-column minWidth=100 field="status"
                    *ngIf="ListCEInputProperty.details.Dynamictype == 'Client' &&  ListCEInputProperty.details?.dynamicClientType !='Employee'"
                    headerText="Onboard Status" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="status"
                    *ngIf="ListCEInputProperty.details.Dynamictype == 'Employee' || ListCEInputProperty.details?.dynamicClientType =='Employee'"
                    headerText="Employee Status" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="employerStatus"
                    *ngIf="ListCEInputProperty.details.Dynamictype == 'Employee' || ListCEInputProperty.details?.dynamicClientType =='Employee'"
                    headerText="Employer Status" type="string">
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 *ngIf="global.OnboardingLoginType !='onboardLogin'" field="officeNotes"
                    headerText="Office Notes" type='string'>
                    <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                    </ng-template>
                </e-column>
                <e-column minWidth=100 field="isCompleted" headerText="Is Completed?" textAlign="center">
                    <ng-template #filterTemplate let-data>
                        <ejs-dropdownlist
                        placeholder='Select status'
                        foreignKeyValue="Status" 
                        foreignKeyField="Value" 
                        [dataSource]='dropdatas'
                        [fields]="fields"
                        [popupHeight]='height' ></ejs-dropdownlist>
                    </ng-template>
                    <ng-template #template let-data>

                        <button ejs-button class="border-0" *ngIf="data.isCompleted ==false" title="Not Completed"><i
                                class="fa fa-times" style="font-size:30px; color:red;"></i></button>
                        <button ejs-button class="border-0" *ngIf="data.isCompleted ==true" title="Completed"><i
                                class="fa fa-check" style="font-size:30px; color:green;"></i></button>

                    </ng-template>
                </e-column>
                <e-column width="50" [showInColumnChooser]='false'>
                    <ng-template #headerTemplate let-data>
                        <div class="d-none d-lg-block">
                            <span id='show' (click)='showDFT()'><i class="fa fa-cog fa-lg" aria-hidden="true">
                                </i></span>
                        </div>
                    </ng-template>
                </e-column>
            </e-columns>
        </ejs-grid>
    </div>
</div>
<!-- View Template -->
<span id="openViewModal" data-bs-target="#viewTemplatemodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="viewTemplatemodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog " role="document"
        style="max-width: 100%; margin: 0; top: 0; bottom: 0; left: 0; right: 0; height: 100vh; display: flex; position: fixed; z-index: 100000;">
        <div class="modal-content">
            <div class="modal-header card-show">
                <div class="col-lg-3">
                    <h5 class="modal-title font-header" id="exampleModalLabel"><span> View
                            Template </span> </h5>
                </div>
                <div class="col-lg-8">
                    <button type="button" class="btn blue-btn btn-sm text_right ms-1 mb-1 " data-bs-dismiss="modal"
                        (click)="destroyInterval()">Close</button>
                    <button type="button" class="btn blue-btn btn-sm text_right ms-1 mb-1 "
                        (click)="updatedynamicForm(false)">Update</button>


                    <button type="button" type="button"
                        *ngIf="(ListCEInputProperty.details.Dynamictype == 'Client' || ListCEInputProperty.details.Dynamictype == 'Employee')&& this.global.LoginUserType == 'Onboard'"
                        class="btn blue-btn btn-sm text_right ms-1 mb-1  " (click)="Submit()">
                        Submit</button>

                    <button type="button" type="button"
                        *ngIf="(ListCEInputProperty.details.Dynamictype == 'Client') && this.global.LoginUserType != 'Onboard' && TempViewData?.status == 'Pending'"
                        class="btn blue-btn btn-sm text_right ms-1 mb-1" data-bs-target="#mailModal"
                        data-bs-toggle="modal" (click)="clearMailMessage('')">Send To Client</button>
                    <button type="button" type="button"
                        *ngIf="(ListCEInputProperty.details.Dynamictype == 'Client' || ListCEInputProperty.details.Dynamictype == 'Employee') && this.global.LoginUserType != 'Onboard' && TempViewData?.status == 'Submitted'"
                        class="btn blue-btn btn-sm text_right ms-1 mb-1" (click)="complete()">Complete</button>
                    <button type="button" type="button"
                        *ngIf="ListCEInputProperty.details.Dynamictype == 'Employee' && this.global.LoginUserType != 'Onboard' && TempViewData?.employerStatus == 'Pending'"
                        class="btn blue-btn btn-sm text_right ms-1 mb-1" data-bs-target="#mailModal"
                        data-bs-toggle="modal" (click)="clearMailMessage('Employer')">Send To Employer</button>
                    <button type="button" type="button"
                        *ngIf="ListCEInputProperty.details.Dynamictype == 'Employee' && this.global.LoginUserType != 'Onboard' && TempViewData?.status == 'Pending'"
                        class="btn blue-btn btn-sm text_right ms-1 mb-1" data-bs-target="#mailModal"
                        data-bs-toggle="modal" (click)="clearMailMessage('Employee')">Send To Employee</button>


                    <!-- <button class="btn blue-btn btn-sm text_right ms-1 mb-1 " (click)="downloadPdf()"><span>
                            Download</span>
                    </button> -->
                </div>
            </div>
            <div class="modal-body" *ngIf="pdfsrc!=null && pdfsrc!=undefined && pdfsrc!=''">
                <!-- <pdf-viewer [src]="pdfsrc" [render-text]="true" style="display: block;height:500px"></pdf-viewer> -->
                <ngx-extended-pdf-viewer [src]="pdfsrc" useBrowserLocale="true"></ngx-extended-pdf-viewer>
            </div>
            <div class="modal-footer">
            </div>
        </div>
    </div>
</div>

<!-- Mail Template -->
<span id="openMailModal" data-bs-toggle="modal" data-bs-target="#mailModal"></span>
<div class="modal hide fade modalbackgrod" id="mailModal" data-bs-backdrop="static">
    <div class="modal-dialog modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">
                    <span>Mail Notes</span>
                </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <p>Notes</p>
                <label class="mx-auto" style="font-size: 12px; color: red;"><i
                        class="fa fa-info-circle fa-lg"></i>&nbsp;
                    This will be attached above in this mail</label>
                <textarea class="form-control" [(ngModel)]="MailMessage"> </textarea>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn  btn-sm" (click)="SendToPortalwithMail()">Submit</button>

                <button type="button" class="btn  btn-sm" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<!-- Delete Template -->
<span id="deletedocument" data-bs-toggle="modal" data-bs-target="#deletedoc"></span>
<div class="modal hide fade modalbackgrod" id="deletedoc" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog  ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel">Delete Record</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body ">
                Do you want to delete this record ?
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="checkDeleteType()">Yes</button>

                <button type="button" class="btn btn-sm btn-primary" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>

<!-- Office Notes  -->
<span id="openOfficeNotes" data-bs-toggle="modal" data-bs-target="#modalofficeNotes"></span>
<div class="modal hide modalbackgrod" id="modalofficeNotes" tabindex="-1" aria-labelledby="modalofficeNotesLabel"
    aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog  ">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="modalofficeNotesLabel">Office Notes</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body ">
                <div class="row">
                    <div class="col-lg-4">
                        <label class="mt-4">Notes<sup class="super-script">&nbsp;*&nbsp;</sup> </label>
                    </div>
                    <div class="col-lg-6">
                        <textarea class="form-control" style="width: 249px;height: 72px;" [(ngModel)]="officeNotes">
                        </textarea>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm" (click)="saveOfficeNotes()" [disabled]="officeNotes == null ||
                officeNotes == undefined || officeNotes?.trim()?.length == 0"><span>Save</span>
                </button>
                <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<!-----View Completed Document-->
<!-- <span id="opencompltedDocModal" data-bs-target="#viewCompltedmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="viewCompltedmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="false">
    <div class="modal-dialog" role="document"
       >
        <div class="modal-content">
            <div class="modal-header card-show">
                <div class="col-lg-8">
                    <h5 class="modal-title font-header" id="exampleModalLabel"><span> View
                            Template </span> </h5>
                </div>
                <div class="col-lg-3">
                    <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Close</button>
                   
                   
                </div>
            </div>
            <div class="modal-body" *ngIf="pdfsrc!=null && pdfsrc!=undefined && pdfsrc!=''">
                <pdf-viewer [src]="pdfsrc" [render-text]="true" style="display: block;height:500px"></pdf-viewer>
            </div>
           
        </div>
    </div>
</div> -->

<span id="opencompltedDocModal" data-bs-target="#viewCompltedmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="viewCompltedmodal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
        <div class="modal-content">
            <div class="modal-header card-show">
                <div class="col-lg-3">
                    <h5 class="modal-title font-header" id="exampleModalLabel"><span> View
                            Template </span> </h5>
                </div>
                <div class="col-lg-8">
                    <button type="button" class="btn blue-btn btn-sm text_right ms-1 mb-1 " data-bs-dismiss="modal"
                        (click)="destroyInterval()">Close</button>
                </div>
            </div>
            <div class="modal-body" *ngIf="pdfsrc!=null && pdfsrc!=undefined && pdfsrc!=''">
                <pdf-viewer [src]="pdfsrc" [render-text]="true"></pdf-viewer>
            </div>
            <div class="modal-footer">
            </div>
        </div>
    </div>
</div>